import { ModalOptionsView } from '../../../shared/views/ModalOptionsView';
import { ZenputFiles } from '../../../shared/models/files';
import { BaseFieldView } from '../BaseField/views';
import { createUUID } from '../../../../backbone-unorganized/utils/files';
import { CordovaPlugins, FILE_UPLOAD_MAX_SIZE, ZENCAM_ERROR_CODES } from '../../../../shared/CordovaPlugins';
import { isAndroid, isIos, isWeb, isWindows } from '../../../../shared/utils/is';
import { actionSheet, showErrorMessage } from '../../../../shared/utils/notifications';

export const DocumentFieldModal = ModalOptionsView.extend({
    class_name: 'document',
    top: '20%',
    right: 0,
    text: 'mobile_field_document_message_delete',
    buttons: ['mobile_drafts_button_delete', 'mobile_action_sheet_cancel']
});

export const DocumentFieldThumbnailItem = Backbone.Marionette.ItemView.extend({
    template: '#tpl_document_field_thumbnail_item',
    model: null, // ZenputFile
    form_field: null, // MobileDocumentField
    allow_delete: function () {
        return false;
    },
    is_draft: false,

    events: {
        'click .document_field.view_pdf': 'view_document'
    },

    templateHelpers: function () {
        return {
            documentName: this.form_field.get_display_name(this.model.id),
            url: this.form_field.get_url(this.model.id),
            documentSize: this.form_field.get_display_size(this.model.id),
            allow_multiples: this.form_field.allow_multiple || false
        };
    },

    initialize: function (options) {
        options || (options = {});
        $.extend(this, options);
    },

    _to_file_collection: function (arr) {
        var this_ = this;

        return new ZenputFiles(
            _.map(arr, function (file, index) {
                if (!file) {
                    return null;
                }

                var is_remote_document = _.contains(this_.form_field.get('value') || [], file);

                if (is_remote_document) {
                    return { url_s3: file };
                }
            })
        );
    },

    view_document: function (event) {
        event.preventDefault();
        var this_ = this;

        if (!!this.form_field.get('value') && !!this.form_field.collection.smetadata.get('date_submitted')) {
            // submission review
            if (isWeb()) {
                $f.mobile.open_uri(this.form_field.get_url(this.model.id));
            } else {
                this._view_document();
            }

            return false;
        }

        if (!isWeb()) {
            var button_rect = this.$el.find('.view_pdf').get(0).getBoundingClientRect();
            var button_labels_view = _t('mobile_field_document_alret_button_view');
            var android_and_windows_labels = [button_labels_view, _t('mobile_drafts_button_delete')];

            var options = {
                position: [button_rect.left - 20, button_rect.top + 20], // for iPad
                addCancelButtonWithLabel: _t('mobile_action_sheet_cancel')
            };

            if (isIos()) {
                options.buttonLabels = [button_labels_view];
                options.addDestructiveButtonWithLabel = _t('mobile_drafts_button_delete');
                options.destructiveButtonLast = true;
            }

            if (isAndroid()) {
                options.buttonLabels = android_and_windows_labels;
            }

            actionSheet(options, function (button_index) {
                if (button_index === 3) {
                    return; // cancel
                }
                if (button_index === 1) {
                    // view document
                    return this_._view_document();
                }

                return this_._delete_document();
            });

            return;
        }

        return $f.application.content_overlay.show(
            new DocumentFieldModal({
                callback: function (button_idx) {
                    // 1 = delete, 2 = cancel
                    if (button_idx === 1) {
                        return this_._delete_document();
                    }
                }
            })
        );
    },

    _delete_document: function () {
        var this_ = this;
        var indexes = this.form_field.get('metadata').file_metadata.map(function (file) {
            return file.file_id;
        });
        var index = indexes.indexOf(this.model.id);
        var to_delete = null;
        if (this.form_field.get('file')) {
            to_delete = new ZenputFiles(this.form_field.get('file').at(index));
        } else {
            to_delete = this_._to_file_collection(this.form_field.get('value'));
        }
        this.form_field.save_files({ delete: to_delete });
        return;
    },

    _view_document: function () {
        var success = function () {};
        var error = function (_error) {
            $f.mobile.logging.log_error(_error);
        };

        if (isWeb()) {
            return;
        }

        if (this.form_field.get('value')) {
            // drafts & submission review. Note that if we are planning on adding multiple document support to documents in form fields, we will need to update this check.
            CordovaPlugins().zencam.viewDocumentRemote(
                {
                    path: $f.storage.get_storage_full_url(this.model.get('url_s3')),
                    original_name: this.form_field.get_display_name(this.model.id)
                },
                success,
                error
            );
        } else {
            CordovaPlugins().zencam.viewDocument(
                {
                    path: this.model.get('url_native'),
                    original_name: this.form_field.get_display_name(this.model.id)
                },
                success,
                error
            );
        }
        return;
    }
});

export const DocumentFieldViewThumbnails = Backbone.Marionette.CollectionView.extend({
    itemView: DocumentFieldThumbnailItem,
    itemViewEventPrefix: 'thumbnail',

    collection: null, // ZenputFiles
    form_field: null, // MobileBaseField

    allow_delete: function () {
        return false;
    },

    itemViewOptions: function () {
        return {
            collection: this.collection,
            allow_delete: this.allow_delete,
            form_field: this.form_field,
            is_draft: this.is_draft
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    }
});

export const DocumentFieldView = BaseFieldView.extend({
    template: '#tpl_document_field',
    model: null, // MobileDocumentField
    file: null,

    events: {
        'change .file_upload': 'browse_files',
        'click .upload_document': 'on_upload_clicked'
    },

    regions: {
        r_file_preview: '.file_preview'
    },

    templateHelpers: function () {
        return $.extend(DocumentFieldView.__super__.templateHelpers.apply(this, arguments), {
            has_value: this.model.get('value') || this.model.get('file'),
            allow_multiples: this.model.allow_multiple || false,
            isWeb: isWeb(),
            isWindows: isWindows()
        });
    },

    allow_delete: function () {
        return $('.historical_submission').length === 0;
    },

    onRender: function () {
        var this_ = this;
        var is_draft =
            this.model.collection && this.model.collection.is_draft ? this.model.collection.is_draft() : false;

        // Make sure we have auth in case we're showing already uploaded images.
        // In most cases, we'll already have it and this will take no additional time.
        $f.storage.refresh({
            complete: function () {
                if (!this_.r_file_preview) {
                    return;
                }
                this_.r_file_preview.show(
                    new DocumentFieldViewThumbnails({
                        form_field: this_.model,
                        collection: this_.model.get_local_and_remote_files(),
                        allow_delete: this_.allow_delete,
                        is_draft: is_draft
                    })
                );
            }
        });
    },

    on_upload_clicked: function (event) {
        var this_ = this;
        event.preventDefault();

        if (this.model.collection) {
            this.model.collection.smetadata.set('date_modified', { $date: new Date().getTime() });
        }

        if (isWeb()) {
            this.browse_files(event);
            return false;
        }

        CordovaPlugins().zencam.pickDocument(
            {
                error_codes: ZENCAM_ERROR_CODES,
                file_upload_max_size: FILE_UPLOAD_MAX_SIZE
            },
            function (files) {
                this_.on_collect_media_success(this_._to_file_collection(files));
            },
            function (error) {
                var error_display_message = '';
                switch (error) {
                    case ZENCAM_ERROR_CODES.file_size_too_large_error:
                        error_display_message = _t('mobile_field_document_alert_file_size_error', {
                            count: FILE_UPLOAD_MAX_SIZE / 1000000
                        });
                        break;
                    default:
                        error_display_message = _t('mobile_field_document_alert_error');
                        break;
                }

                $f.mobile.logging.log_error('Failed to pick document', {
                    error: error,
                    display_error_message: error_display_message
                });

                showErrorMessage(error_display_message);
            }
        );

        this.trigger('prevent_next_reload_on_resume');
    },

    _to_file_collection: function (arr) {
        var this_ = this;

        return new ZenputFiles(
            _.map(arr, function (file, index) {
                if (!file) {
                    return null;
                }

                var is_remote_document = _.contains(this_.model.get('value') || [], file);
                var model_dict = {};

                if (is_remote_document) {
                    model_dict.url_s3 = file;
                    return model_dict;
                }

                if (file.url.indexOf('://') === -1) {
                    file.url = `file://${file.url}`;
                }

                model_dict = {
                    id: createUUID(index),
                    mimetype: file.mimetype,
                    url_native: file.url,
                    metadata: { name: file.name, size: file.size } // adding those here because we override raw file on native
                };

                return model_dict;
            })
        );
    },

    browse_files: function (event) {
        var this_ = this;
        $f.mobile.uploads.web_filestore.pick_new_file(
            {
                allowed_file_types: $f.utils.ACCEPTED_DOCUMENT_FILED_TYPES,
                allow_multiple: false
            },
            function (files) {
                if (files.at(0).get('raw_file').size > FILE_UPLOAD_MAX_SIZE) {
                    alert(
                        _t('mobile_field_document_alert_file_size_error', {
                            count: FILE_UPLOAD_MAX_SIZE / 1000000
                        })
                    );
                    return;
                }
                this_.on_collect_media_success(files);
            }
        );

        return;
    },

    on_collect_media_success: function (files) {
        if (files.length === 0) {
            // We didn't actually get a file. Probably because the dialog was canceled.
            return;
        }
        this.file = files.at(0);
        this.model.is_valid = true;
        this.$el.removeClass('invalid');
        this.model.save_files({ add: files });
    }
});
